export default "__VITE_ASSET__ByVrh0S4__"